/**
 * CZNA-1352 — a vocabulary create/update answers 409 for three different reasons, told apart
 * only by the message the backend puts into `error`: a duplicate code, a duplicate name (two
 * live terms of one vocabulary may not share a name, case aside — publish could not link a
 * draft's text to either), and, on update only, an optimistic-lock conflict. Each form used to
 * map 409 to a single reason, so a duplicate name read as "this code exists" on create and as
 * "someone else edited it" on update.
 */
export var vocabularyConflictMessageId = function (errorInfo, fallbackId) {
    var _a;
    var message = (_a = errorInfo.message) !== null && _a !== void 0 ? _a : '';
    if (message.startsWith('Duplicate term')) {
        return 'ui-czna-authorities.vocabularies.error.duplicateName';
    }
    if (message.startsWith('Duplicate code')) {
        return 'ui-czna-authorities.vocabularies.error.duplicate';
    }
    return fallbackId;
};
